export function Wordmark({ compact = false }: { compact?: boolean }) {
  return (
    <div className={compact ? 'leading-tight' : 'leading-snug'}>
      <p
        className={`font-display font-normal uppercase tracking-brand text-crimson ${
          compact ? 'text-sm sm:text-base' : 'text-xl sm:text-2xl'
        }`}
      >
        FESTIVALSOFINDIASTORE
      </p>
      <p
        className={`mt-1 font-sans font-bold uppercase tracking-brand text-kraft ${
          compact ? 'text-[0.65rem]' : 'text-xs'
        }`}
      >
        UtsavVoice
      </p>
    </div>
  );
}
